import React from 'react';
import { CircularProgress } from '@material-ui/core';
import './Loader.css';

const Loader = (props) => {
	const { id, height } = props;

	let className = height === 'full' ? 'loader-container' : 'loader-container h-100' 

	return (
		<div className='loader-size-wrapper' id={id}>
			<div className={className}>
				<CircularProgress />
			</div>
		</div>
	);
};

export default Loader;
